import {
    setCheckOrderFatalError,
    setCheckOrderUserMessages,
    setPassengerDataUpdating, showCheckOrderModals
} from "@CheckOrder/reducers/checkOrderSlice";
import {useAppDispatch} from "@Hooks/dispatch/useAppDispatch";
import useGoBack from "@Routing/hooks/useGoBack";

export default function useHandleCheckOrderError() {
    const dispatch = useAppDispatch()
    const {goBack} = useGoBack()

    const handleError = (condition: boolean) => {
        if (condition) {
            dispatch(showCheckOrderModals(false))
            dispatch(setCheckOrderFatalError(false))
            dispatch(setPassengerDataUpdating(false))
            dispatch(setCheckOrderUserMessages([]))
        } else {
            goBack()
        }
    }

    return {
        handleError,
    }
}